var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"select"},[_c('option',{staticClass:"option"},[_vm._v("RU")]),_c('option',[_vm._v("EN")]),_c('option',[_vm._v("ES")])])}]

export { render, staticRenderFns }